import { Button } from '@/lib';
import { TranslationKeys } from '@/localization';
import { FC, ReactNode } from 'react';
import { Trans, useTranslation } from 'react-i18next';

type CongratulationScreenProps = {
  title: TranslationKeys;
  subtitle: TranslationKeys;
  primaryButton?: {
    text: TranslationKeys;
    icon?: ReactNode;
    onClick: VoidFunction;
  };
  secondaryButton?: {
    text: TranslationKeys;
    icon?: ReactNode;
    onClick: VoidFunction;
  };
  showHeader?: boolean;
};

export const CongratulationScreen: FC<CongratulationScreenProps> = ({ title, subtitle, primaryButton, secondaryButton, showHeader = false }) => {
  const { t } = useTranslation();

  return (
    <div className='flex flex-col gap-12'>
      {showHeader && <h1 className='text-center text-6xl font-semibold text-brand-600'>{t('ALL:congratulation')}</h1>}
      <div>
        <img className='mx-auto my-0' src='/assets/image/bg-congratulation-screen.svg' />
        <div className='flex flex-col gap-5 p-6'>
          <div>
            <h2 className='text-center font-semibold text-primary-900'>
              <Trans
                i18nKey={title as any}
                components={{
                  highlight: <span className='text-brand-600' />,
                }}
              />
            </h2>
            <p className='text-center text-sm text-tertiary-600'>{t(subtitle as any)}</p>
          </div>
          <div className='flex items-center justify-center gap-3'>
            {secondaryButton && (
              <Button intent='secondary' onClick={secondaryButton.onClick}>
                {secondaryButton.icon} {t(secondaryButton.text as any)}
              </Button>
            )}

            {primaryButton && (
              <Button intent='primary' onClick={primaryButton.onClick}>
                {primaryButton.icon} {t(primaryButton.text as any)}
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
